
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Determine if we are on the home page
  const isHomePage = location.pathname === '/';

  const navLinks = [
    { name: '首页', path: '/' },
    { name: '认识1039', path: '/policy' },
    { name: '适配测试', path: '/test' },
    { name: '成功案例', path: '/cases' },
    { name: '物流仓储', path: '/logistics' },
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHomePage ? 'bg-white shadow-lg' : 'bg-primary/85'
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-8 py-4 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/816962de-bbe8-40db-8d72-21e4147c0bd7.png"
            alt="白云天健1039市采易"
            className="h-10 w-auto object-contain"
          />
          <div className="flex flex-col">
            <span
              className={`text-lg font-bold whitespace-nowrap ${
                isScrolled || !isHomePage ? 'text-primary' : 'text-white'
              }`}
            >
              1039市采易
            </span>
            <span
              className={`text-xs whitespace-nowrap ${
                isScrolled || !isHomePage ? 'text-neutral-500' : 'text-white/80'
              }`}
            >
              白云天健 · 数字化服务平台
            </span>
          </div>
        </Link>

        {/* Navigation Items */}
        <div className="flex items-center gap-8">
          {navLinks.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-base font-medium whitespace-nowrap transition-all duration-300 relative group cursor-pointer ${
                isScrolled || !isHomePage
                  ? 'text-neutral-600 hover:text-primary'
                  : 'text-white hover:text-accent'
              } ${
                location.pathname === item.path
                  ? isScrolled || !isHomePage
                    ? 'text-primary'
                    : 'text-accent'
                  : ''
              }`}
            >
              {item.name}
              <span
                className={`absolute bottom-0 left-0 h-0.5 transition-all duration-300 group-hover:w-full ${
                  isScrolled || !isHomePage ? 'bg-accent' : 'bg-accent'
                } ${location.pathname === item.path ? 'w-full' : ''}`}
              />
            </Link>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="flex items-center gap-4">
          <Link
            to="/test"
            className="px-6 py-3 bg-gradient-to-r from-accent to-accent-dark text-primary font-semibold rounded-full whitespace-nowrap transition-all duration-300 hover:shadow-lg hover:scale-105 flex items-center gap-2 cursor-pointer"
          >
            开始测试
            <i className="ri-arrow-right-line"></i>
          </Link>
          <button
            className={`px-6 py-3 border-2 font-semibold rounded-full whitespace-nowrap transition-all duration-300 hover:scale-105 cursor-pointer ${
              isScrolled || !isHomePage
                ? 'border-primary text-primary hover:bg-primary hover:text-white'
                : 'border-white text-white hover:bg-white hover:text-primary'
            }`}
          >
            立即入驻
          </button>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
